/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

const configuration = {
  react_env: import.meta.env.VITE_REACT_ENV,
  domain: import.meta.env.VITE_DOMAIN,
  backend_url: import.meta.env.VITE_API_URL, // Fixed: Use VITE_API_URL (matches .env.example)
  better_auth_url: import.meta.env.VITE_BETTER_AUTH_URL,
  better_auth_frontend_url: import.meta.env.VITE_BETTER_AUTH_FRONTEND_URL,
  // Issue 1/11 (FCR Pass 10): Auth Service frontend URL and login path.
  // VITE_AUTH_FRONTEND_URL falls back to VITE_BETTER_AUTH_FRONTEND_URL so
  // no env change is required today. auth_login_path flips from /shop/ to
  // /auth at Wave C cutover by setting VITE_AUTH_LOGIN_PATH=/auth.
  auth_frontend_url: import.meta.env.VITE_AUTH_FRONTEND_URL,
  auth_login_path: import.meta.env.VITE_AUTH_LOGIN_PATH,
  frontend_url: import.meta.env.VITE_DOMAIN,
  stripe: {
    publishable_key: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
  },
  google_maps_api_key: import.meta.env.VITE_GOOGLE_MAP_API_KEY,
  sentry_dsn: import.meta.env.VITE_SENTRY_DSN,
};

export default configuration;
